import { useLayoutEffect, useRef, useMemo } from 'react';
import { TOP_NAV } from '@atlassian/jira-spa-state-controller/src/common/constants.tsx';
import { useSpaStateActions } from '@atlassian/jira-spa-state-controller/src/common/index.tsx';
import { usePageId } from '@atlassian/jira-spa-state-controller/src/components/use-page-id/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';

/**
 * The start tracker for atlassian navigation, what it records,
 * spa app TOP_BAR start
 *
 * start condition, new route and the route is not a redirect
 */
export const AtlassianNavigationStart = () => {
	const [{ location }] = useRouter();
	const { setAppStartWithAppId } = useSpaStateActions();
	usePageId();

	const startRef = useRef({
		location,
		startTime: Date.now(),
	});

	useMemo(() => {
		if (location !== startRef.current.location) {
			startRef.current = {
				location,
				startTime: Date.now(),
			};
		}
	}, [location]);

	useLayoutEffect(() => {
		setAppStartWithAppId(TOP_NAV, startRef.current.startTime);
	}, [location, setAppStartWithAppId]);

	return null;
};
